import { render, staticRenderFns } from "./DashboardTestfields.vue?vue&type=template&id=3eb35066&scoped=true"
import script from "./DashboardTestfields.vue?vue&type=script&lang=js"
export * from "./DashboardTestfields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb35066",
  null
  
)

export default component.exports